import * as types from "../ActionType";
import axios from "axios";
import { notifyError, notifysuccess } from "../../components/general/Notification";
import { hasExpirition } from "../../components/general/general-component/abstruct-component/useExpirition";
import { usersApi } from "../../api/Instances";
const END_POINT = process.env.REACT_APP_BASE_URL_PERMISSIONS;

const get = (arr, type) => {
    return ({
        type: type,
        payload: arr
    })
}
const add = (type) => {
    return ({
        type: type
    })
}
const delelte = (type) => {
    return ({
        type: type
    })
}
const edit = (type) => {
    return ({
        type: type
    })
}

export const postUser = (state, setLoad) => {
    return async function (dispatch) {
        setLoad(true);
        try {
            const response = await usersApi.post("/api/users", state);
            if (response.data.status === "Success") {
                dispatch({ type: types.ADD_USER });
                dispatch(loadUsers());
                notifysuccess(response.data.message);
            }
        } catch (error) {
            notifyError(error.response?.data?.message || "Error occurred");
        } finally {
            setLoad(false);
        }
    };
};

export const loadUsers = () => {
    return async function (dispatch) {
        try {
            const response = await usersApi.get("/api/users");
            if (response.data.status === "Success") {
                dispatch(get(response.data.data,types.GET_USERS))
               
            }
        } catch (error) {
            notifyError(error.response?.data?.message || "Error occurred");
        }
    };
};

export const deleteUser = (id, setLoadDel, setIsDeleted, setIdDeleted) => {
    return async function (dispatch) {
        setLoadDel(true);
        try {
            const response = await usersApi.delete(`/api/users/${id}`);
            if (response.data.status === "Success") {
                dispatch({ type: types.DELETE_USER });
                notifysuccess(response.data.message);
                setIsDeleted("deleted");
                setIdDeleted(id);
            }
        } catch (error) {
            notifyError(error.response?.data?.message || "Error occurred");
        } finally {
            setLoadDel(false);
        }
    };
};


export const putUser = (id, name, email, password, role, setLoad) => {
    return async (dispatch) => {
        setLoad(true);

        const formValues = {
            name,
            email,
            role,
        };
        if (password !== "") {
            formValues.password = password;
        }

        try {
            const response = await usersApi.put(`/api/users/${id}`, formValues);

            if (response.data.status === "Success") {
                dispatch(edit(types.EDIT_USER));
                dispatch(loadUsers());
                notifysuccess(response.data.message);
            }
        } catch (error) {
            notifyError(error.response?.data?.message || "Something went wrong");
        } finally {
            setLoad(false);
        }
    };
};


export const filterUser = (name, email, role, setLoad) => {
    return async (dispatch) => {
        setLoad(true);

        // بناء الـ query params
        const queryParams = [];
        if (name !== "") queryParams.push(`filters[name]=${name}`);
        if (email !== "") queryParams.push(`filters[email]=${email}`);
        if (role !== "") queryParams.push(`filters[role]=${role}`);
        const finalQuery = queryParams.join("&");

        try {
            const response = await usersApi.get(`/api/users?${finalQuery}`);
            dispatch(get(response.data.data, types.GET_USERS));
        } catch (error) {
            console.error("Filter User Error:", error.response?.data?.message || error.message);
        } finally {
            setLoad(false);
        }
    };
};

export const blockUser = (id, status, setLoad) => {
    return async (dispatch) => {
        setLoad(true);

        try {
            const response = await usersApi.put(`/api/users/${id}/update-status`, { status });
            if (response.data.status === "Success") {
                dispatch(edit(types.BLOCK_USER));
                dispatch(loadUsers());
                notifysuccess(response.data.message);
            }
        } catch (error) {
            notifyError(error.response?.data?.message || "Something went wrong");
        } finally {
            setLoad(false);
        }
    };
};
